const videos = [
	{
		url: "https://www.youtube.com/watch?v=bJ-hhTHaqgM",
		thumbNail: "https://img.youtube.com/vi/bJ-hhTHaqgM/0.jpg",
		title: "The New & Improved Sublime Text 4 ",
	},
	{
		url: "https://youtu.be/GPR7OQBx2jQ",
		thumbNail: "https://img.youtube.com/vi/GPR7OQBx2jQ/0.jpg",
		title: "Get Started With React ! | React Series #1",
	},

	{
		url: "https://youtu.be/uTmWNumMSnM",
		thumbNail: "https://img.youtube.com/vi/uTmWNumMSnM/0.jpg",
		title: "10 Sites To Get Remote Developer Jobs !",
	},
	{
		url: "https://youtu.be/9y-boICNJSA",
		thumbNail: "https://img.youtube.com/vi/9y-boICNJSA/0.jpg",
		title: "Relational & Non-Relational Database - Difference !",
	},
	{
		url: "https://www.youtube.com/watch?v=4TnxVkWb6ug&t=1s",
		thumbNail: "https://img.youtube.com/vi/4TnxVkWb6ug/0.jpg",
		title: "Why Typescript over Javascript ?",
	},
	{
		url: "https://www.youtube.com/watch?v=sUF7qa0cvOk",
		thumbNail: "https://img.youtube.com/vi/sUF7qa0cvOk/0.jpg",
		title: "Programmed for 13 HOURS Straight !",
	},
];
export default videos;
